import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";

const LinkBehavior = forwardRef((props, ref) => (
  <RouterLink ref={ref} to={props.href || "/"} {...props} />
));

const Link = {
  defaultProps: {
    underline: "none",
    component: LinkBehavior,
  },
  styleOverrides: {},
};

export default Link;
